import { DEFAULT_LANGUAGE } from '@/configs/constants';
import { LANGUAGES_SUPPORTED } from '@/types/enums';
import i18n, { InitOptions } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

// Được inject lúc build qua DefinePlugin (config-overrides.js). Đổi mỗi lần build
// để bust cache file translation.json; fallback 'dev' khi chạy test/không có define.
declare const __APP_BUILD_ID__: string;
const I18N_BUILD_ID = typeof __APP_BUILD_ID__ !== 'undefined' ? __APP_BUILD_ID__ : 'dev';

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: DEFAULT_LANGUAGE,
        lng: DEFAULT_LANGUAGE,
        supportedLngs: Object.values(LANGUAGES_SUPPORTED),
        debug: false,
        detection: {
            order: [
                'querystring',
                'cookie',
                'sessionStorage',
                'localStorage',
                'navigator',
                'htmlTag'
            ],
            caches: ['cookie']
        },
        backend: {
            loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/translation.json?v=${I18N_BUILD_ID}`
        } as HttpBackendOptions,
        interpolation: {
            escapeValue: false
        }
    } as InitOptions);

export default i18n;
